import * as React from "react";
import { Route } from "react-router-dom";

const RouteWithSubRoutes = (route: any) => (
  <Route
    path={route.path}
    exact={route.exact}
    render={(props: any) => (
      <route.component {...props} routes={route.routes} />
    )}
  />
);

export default RouteWithSubRoutes;
